import { I18n } from '@calendly/i18n';
import { BookmarkTagIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { isEmpty } from 'lodash-es';
import { forwardRef } from 'react';
import { WidgetContainer } from './widget_container';
const paramContainerCss = "pog20oo";
const ParamContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paramContainerCss, props.className)} />;
});
export const UtmParamsWidget = ({
  event
}) => {
  const params = event?.invitee?.trackingParams?.map(({
    label,
    value
  }) => ({
    label,
    value
  })) || [];
  if (isEmpty(params)) return null;
  return <WidgetContainer title={I18n.t('publisher.meetings.utm_params')} showBorder={false} sectionWithBottomBorder noPadding>
      {params.map(({
      label,
      value
    }) => <ParamContainer key={label}>
            <BookmarkTagIcon />
            <BodyText>
              {label}
              =
              {value}
            </BodyText>
          </ParamContainer>)}
    </WidgetContainer>;
};

require("./utm_params_widget.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./utm_params_widget.js");